module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Astronomic coordinates","eclipticCoordinates":"Ecliptic coordinates","equatorialCoordinates":"Equatorial coordinates","distance":"Distance","eclipticObliquity":"Obliquity of the ecliptic","declination":"Declination of the sun (approximation of ","hourAngle":"Hour angle at sunrise(sunset)"},"ru":{"title":"Астрономические координаты","eclipticCoordinates":"Эклиптические координаты","equatorialCoordinates":"Экваториальные координаты","distance":"Расстояние","eclipticObliquity":"Наклон эклиптики","declination":"Солнечное склонение (аппроксимация ","hourAngle":"Часовой угол в момент (восход/закат)"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/coordinates.vue
// module id = 724
// module chunks = 0